import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CiSearch } from "react-icons/ci";
import { useStores } from "../../store";
import _ from "lodash";
import { useObserver } from "mobx-react";
import constantVariables from "../../helpers/constantVariables";
import { CiWarning } from "react-icons/ci";
import { IoMdCloseCircleOutline } from "react-icons/io";
import verify from "../../assests/verify.svg";
import ReactPaginate from "react-paginate";
import { MdArrowBack, MdOutlineShareLocation } from "react-icons/md";
import { CiFilter } from "react-icons/ci";

import {
  AiFillCloseCircle,
  AiOutlineFileText,
  AiOutlineVideoCamera,
} from "react-icons/ai";
import { apiPostPut } from "../../api/api_methods";
import HelpCenter from "../reusble_components/helpCenter";
import LoadingAnime from "../reusble_components/loadingAnime";

export default function Recruiter() {
  const navigate = useNavigate();
  const { RecuiterStore, UserStore, PopupStore } = useStores();
  const [filter, setfilter] = useState(true);
  const [jobType, setJobType] = useState("");
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const page = query.get("page") || 0;
  useEffect(() => {
    fetchData(page * 10);
  }, [page]);

  useEffect(() => {
    if (RecuiterStore.search) {
      fetchData(page * 10);
    } else {
      // RecuiterStore.getUsersFromServer();
    }
    UserStore.getUserDetails();
    // setData(toJS(RecuiterStore.Users));
  }, [RecuiterStore.search]);

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCity, setSelectedCity] = useState("");

  const handleIconClick = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const convertTimestampToDate = (timestamp) => {
    const date = new Date(timestamp);

    // Function to get the month name
    const getMonthName = (monthIndex) => {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months[monthIndex];
    };

    // Format the date to 'Month day, year' format
    const formattedDate = `${getMonthName(
      date.getMonth(),
    )} ${date.getDate()}, ${date.getFullYear()}`;

    return formattedDate;
  };

  const handlePageChange = (newPage) => {
    RecuiterStore.currentPage = newPage;
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= RecuiterStore.totalPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          className={`mx-1 px-3 py-1 rounded ${
            i === RecuiterStore.currentPage
              ? "bg-blue-500 text-white"
              : "bg-gray-200"
          }`}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </button>,
      );
    }
    return pageNumbers;
  };

  const goToReport = (id, intervieweeId) => {
    localStorage.setItem("applicantId", intervieweeId);
    navigate(`/company/report/${id}`);
  };
  const closeThisPopUP = () => {
    setDropdownOpen(false);
  };
  const Submit = () => {
    if (selectedCity.length > 0) {
      RecuiterStore.setcity(selectedCity);
    }
    if (jobType.length > 0) {
      RecuiterStore.setLookingFor(jobType);
    }
    if (selectedCity.length > 0 && jobType.length > 0) {
      RecuiterStore.setCount(2);
    }
    if (selectedCity.length === 0 && jobType.length > 0) {
      RecuiterStore.setCount(1);
    }
    if (selectedCity.length > 0 && jobType.length === 0) {
      RecuiterStore.setCount(1);
    }
    RecuiterStore.searchUsers();

    setDropdownOpen(false);
  };
  const Close = () => {
    setSelectedCity("");

    RecuiterStore.setcity("");
    RecuiterStore.searchUsers();
  };
  const [showDiv, setShowDiv] = useState(true);

  const fetchData = async (skip) => {
    RecuiterStore.setLoader(true);
    const body = {
      skip: skip,
      limit: 10,
    };
    if (RecuiterStore.search) {
      body.search = RecuiterStore.search;
    }
    if (RecuiterStore.city) {
      body.city = RecuiterStore.city;
    }
    if (RecuiterStore.LookingFor) {
      body.lookingFor = RecuiterStore.LookingFor;
    }
    const response = await apiPostPut(
      body,
      "/recruiter/get-candidates-with-filter",
      "POST",
    );
    if (response.status === 200) {
      RecuiterStore.setTotalProfiles(response?.body?.count);
      RecuiterStore.setLoader(false);
      RecuiterStore.setUsers(response?.body?.data);
      RecuiterStore.setFilteredUsers(response?.body?.data);
    } else {
      RecuiterStore.setLoader(false);
      alert("Something went wrong! Please try again.");
    }
  };
  const handlePageClick = (page) => {
    // fetchData(page.selected * 10);
    navigate("/company?page=" + page.selected);
    console.log(page.selected);
  };
  const resetFilter = () => {
    RecuiterStore.setCount(0);
    RecuiterStore.setcity(null);
    RecuiterStore.setLookingFor(null);
    setJobType("");
    setSelectedCity("");
    RecuiterStore.searchUsers();
  };

  return useObserver(() => (
    <div className="w-full  items-center flex flex-col bg-white min-h-[100vh] h-[100%] pb-5 gil-reg">
      <HelpCenter />
      {/* <Loader loader={RecuiterStore.loader} /> */}

      {/* <span className="absolute md:top-[14.5%] top-44 right-[24%] flex items-center text-primary opacity-60 ">
        {RecuiterStore.city && (
          <>
            {selectedCity}
            <span className="pl-2 cursor-pointer" onClick={Close}>
              <AiOutlineCloseCircle />
            </span>
          </>
        )}
      </span> */}
      <div className="w-[100%]">
        {UserStore?.showVerificationAlert && (
          <div className="max-sm:mx-[5%]">
            <div className="relative bg-white mt-5 max-sm:px-4 flex flex-row justify-around align-middle max-sm:mx-0 mx-auto mg-agent-shadow w-[95%] max-sm:w-[100%] rounded-xl">
              {/* <img src={verify} className="w-[500px] object-cover "></img> */}
              <div className="verification-icon max-sm:px-0 flex items-center text-[#FFBF00] md:text-7xl px-3 md:w-[8%] ">
                <CiWarning className="text-5xl" />
              </div>
              <div className="flex-col items-center md:text-xl lg:text-2xl text-lg w-[80%] py-4">
                <p className="text-primary text-md md:text-lg font-extrabold ">
                  Your Verification is under Progress
                </p>
                <p className=" text-sm md:text-base text-gray-400">
                  Your account is currently under verification. We appreciate
                  your patience as we ensure the security and accuracy of your
                  information. Once verified, you'll have full access to our
                  platform's features. Thank you for your understanding.
                </p>
                <p>{UserStore?.userDetails?.isAccountVerified}</p>
              </div>
              <div className="absolute md:right-[1.5%] text-2xl md:top-[14%] top-[10%] right-[1%]">
                {" "}
                <button
                  className="text-gray-400 font-bold hover:text-gray-600"
                  onClick={() => UserStore.setVerificationAlert(false)}
                >
                  <IoMdCloseCircleOutline />
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="flex flex-col md:flex-row lg:flex-row justify-center items-center py-4 mx-[3%] mt-10 gap-10 max-sm:mx-[4%]">
          <div className="flex items-center md:px-0 lg:px-0 px-2 w-full">
            <MdArrowBack
              className=" bg-primary2 h-10 p-2 rounded-full w-10 md:mr-2 lg:mr-2 mr-2"
              onClick={() => navigate("/company/instant-hire")}
            />
            <p className="text-xl w-32 h-5">Total Profiles</p>
            <span className="text-4xl font-bold h-8 text-primary">
              {RecuiterStore.totalProfiles}
            </span>
          </div>
          <div className="flex items-center justify-between md:px-0 lg:px-0 px-5  w-full cursor-pointer">
            {/* <div className="text-[11px] px-2 flex justify-end   ">
              {RecuiterStore.count > 0 && (
                <span className="rounded-full relative -top-8   z-10 -mr-24 -mb-1 bg-white py-0.5 px-2">
                  {RecuiterStore.count}
                </span>
              )}
            </div> */}
            <div className="flex md:flex-row lg:flex-row flex-col items-center justify-center gap-10 w-full ">
              {/* <img src={logo} className=" md:w-52 lg:wi52 w-[50%] " /> */}
              {/* <h1 className="text-4xl mx-2 font-bold text-primary">Dashboard</h1> */}
              <div className=" flex items-center w-full justify-end mr-10 ">
                <div className="bg-white  box-shadow-2 relative  max-sm:w-[98%] w-[75%] h-12 flex justify-between px-7 items-center rounded-3xl">
                  <form
                    className="flex w-full"
                    onSubmit={(e) => {
                      e.preventDefault();
                      RecuiterStore.searchUsers();
                    }}
                  >
                    <div className="flex justify-start items-center w-full ">
                      <input
                        defaultValue={RecuiterStore.search}
                        type="text"
                        placeholder="Search by Role or Technology"
                        // ref={searchValue}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            RecuiterStore.setSearching(e.target.value);

                            if (e.target.value.length === 0) {
                              RecuiterStore.showAllUsers();
                            }
                          }
                        }}
                        className=" placeholder-primary truncate text-md md:text-lg outline-none h-10 w-[90%] md:w-[95%]"
                      />
                      <CiSearch className="text-4xl text-primary absolute right-4 md:right-6" />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {/* <MdFilterList className="text-4xl text-primary" /> */}
            <div
              className="flex flex-col box-shadow-2 rounded-lg z-10 bg-white w-fit"
              onClick={handleIconClick}
            >
              <div className="flex flex-row items-center  h-12 w-12  p-1 px-2 py-1 ">
                {/* <p className="text-lg">Filters</p> */}
                <CiFilter className="text-4xl text-primary" />
              </div>
              {RecuiterStore.count > 0 && (
                <div
                  className="flex flex-row justify-center items-center text-primary px-3 py-1 rounded-lg"
                  onClick={(e) => {
                    e.stopPropagation();
                    resetFilter();
                  }}
                >
                  <p className="text-sm">Reset</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {isDropdownOpen ? (
          <div className="  z-50 inset-0  bg-black bg-opacity-40 inline">
            <div
              className={`fixed ${
                UserStore?.showVerificationAlert
                  ? "top-[34%] max-md:top-80 max-sm:top-[48%]"
                  : "top-24 max-md:top-64 max-sm:top-64"
              } max-sm:right-6 right-[3%]  bg-bg3 z-50 flex flex-col  rounded  md:w-[17%]  md:h-fit m-auto shadow-lg overflow-y-auto no-scrollbar`}
            >
              <div className="flex flex-col justify-between  h-full py-5 w-[100%] md:w-[100%] lg:[100%] border ">
                <AiFillCloseCircle
                  className="text-primary absolute text-2xl cursor-pointer  top-2 right-2"
                  onClick={closeThisPopUP}
                />
                <div>
                  <div className="dropdown pt-4 px-4 flex flex-col  space-y-4">
                    {/* Add input field for selecting a city */}
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        RecuiterStore.searchUsers();
                      }}
                    >
                      <label className="flex justify-between items-center">
                        <span>Filter by City</span>
                        <span
                          onClick={() => {
                            resetFilter();
                          }}
                          className="mr-2 text-primary cursor-pointer "
                        >
                          Reset
                        </span>
                      </label>
                      <input
                        type="text"
                        placeholder="City Name"
                        value={selectedCity}
                        onChange={(e) => setSelectedCity(e.target.value)}
                        className="h-10 w-full px-2 border mb-4 border-primary outline-none focus:outline-none "
                      />
                      <div>
                        <label className="px-1 mt-4   gap-6 items-center">
                          <span>Searching For</span>
                          <div className="mt-1">
                            <div className="flex">
                              <input
                                type="radio"
                                id="job"
                                name="selection"
                                checked={jobType === "job"}
                                c
                                value="job"
                                className="mr-2"
                                onChange={(e) => {
                                  setJobType(e.target.value);
                                }}
                                required
                              />
                              <label htmlFor="job" className="text-gray-500">
                                Job
                              </label>
                            </div>

                            <div className="flex">
                              <input
                                type="radio"
                                id="internship"
                                name="selection"
                                checked={jobType === "internship"}
                                value="internship"
                                onChange={(e) => {
                                  setJobType(e.target.value);
                                }}
                                className=" mr-2"
                                required
                              />
                              <label
                                htmlFor="internship"
                                className="text-gray-500"
                              >
                                Internship
                              </label>
                            </div>
                          </div>
                        </label>
                      </div>
                      <div className="flex justify-center pt-2">
                        <button
                          className="bg-primary text-white p-2 w-28 rounded-full font-semibold"
                          onClick={Submit}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>

                {/* <div className="absolute right-5 bottom-10"> <button className="text-primary font-bold">Mark all as read</button></div> */}
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
        <div className="mt-5 flex flex-wrap gap-5 h-fit w-[95%] mx-auto justify-center">
          {RecuiterStore.loader ? (
            <LoadingAnime
              boxHeight="17rem"
              gridColumns="grid-cols-1 max-md:grid-cols-1 md:grid-cols-3 lg:grid-cols-3"
              innerBoxes={[
                //first text
                {
                  width: "5rem", // Circle size
                  height: "5rem",
                  color: "bg-gray-400",
                  shape: "circle",
                  top: "0rem",
                  left: "0.3rem",
                },
                // First   rectangle below the circle for text placeholder
                {
                  width: "50%",
                  height: "12%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  top: "2rem", // Adjust position below the circle
                  left: "6rem",
                },
                {
                  width: "55%",
                  height: "12%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  top: "5.5rem", // Adjust position below the circle
                  left: "0.3rem",
                },
                // Second rectangle for text placeholder
                {
                  width: "23%",
                  height: "12%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  bottom: "0rem", // Adjust position below the first rectangle
                  left: "0.3rem",
                },
                {
                  width: "35%",
                  height: "12%",
                  color: "bg-gray-400",
                  shape: "rectangle",
                  bottom: "0rem", // Adjust position below the first rectangle
                  right: "0.3rem",
                },
                // Large rectangle at the bottom right
                {
                  width: "21%",
                  height: "23%",
                  color: "bg-gray-400",
                  shape: "rectangle", // Align at the bottom right
                  bottom: "3rem",
                  left: "0.3rem",
                },
                {
                  width: "21%",
                  height: "23%",
                  color: "bg-gray-400",
                  shape: "rectangle", // Align at the bottom right
                  bottom: "3rem",
                  left: "5.6rem",
                },
                {
                  width: "21%",
                  height: "23%",
                  color: "bg-gray-400",
                  shape: "rectangle", // Align at the bottom right
                  bottom: "3rem",
                  left: "10.9rem",
                },
              ]}
            />
          ) : (
            <>
              {RecuiterStore.filteredUsers.map((item, key) => (
                <div
                  key={key}
                  className=" w-[100%] shadow-2xl shadow-slate-200 lg:w-[32%] md:w-[32%] min-w-fit px-7 cursor-pointer py-4 bg-white rounded-xl"
                  onClick={() => {
                    goToReport(item?._id, item?.interviewee?._id);
                  }}
                >
                  <div className="flex items-center py-4 gap-4">
                    <img
                      src={
                        item?.interviewee?.pic ??
                        constantVariables.defaultProfilePic
                      }
                      alt=""
                      className="h-20 w-20 rounded-full object-cover"
                    />
                    <div>
                      <h1 className="text-sm gil-med w-40 truncate ">
                        {item?.interviewee?.name
                          ? item?.interviewee?.name
                          : `No name available !`}
                      </h1>
                      <p className=" text-sm opacity-50">
                        {convertTimestampToDate(item?.createdAt)}
                      </p>
                      <p className=" text-xs  flex flex-row items-center ">
                        <MdOutlineShareLocation /> &nbsp;
                        <span className="opacity-30">
                          {" "}
                          {item?.interviewee?.city ?? "No city available !"}
                        </span>
                      </p>
                    </div>
                  </div>
                  <h1 className="my-2 font-semibold tracking-wide text-primary h-6 w-60 truncate">
                    {item?.technology === "" ? item?.role : item?.technology}
                  </h1>
                  {/* interviewData?.technology === "" ? interviewData?.role : interviewData?.technology */}
                  <div className="flex my-3 gap-4">
                    <div>
                      {" "}
                      <h1 className="text-lg font-medium">
                        {Math.trunc(item?.result[2].score)}%
                      </h1>{" "}
                      <p className="text-xs opacity-30">Communication</p>{" "}
                    </div>
                    <div>
                      {" "}
                      <h1 className="text-lg font-medium">
                        {Math.trunc(item?.result[1].score)}%
                      </h1>{" "}
                      <p className="text-xs opacity-30">
                        Technical skills
                      </p>{" "}
                    </div>
                    <div>
                      {" "}
                      <h1 className="text-lg font-medium">
                        {Math.trunc(item?.result[0].score)}%
                      </h1>{" "}
                      <p className="text-xs opacity-30">Overall score</p>{" "}
                    </div>
                  </div>
                  {/* <Link to={`/company/report/${item._id}`}> */}
                  <p
                    className="flex items-center my-4 cursor-pointer "
                    onClick={() => {
                      goToReport(item?._id, item?.interviewee?._id);
                    }}
                  >
                    {" "}
                    {item?.recording ? (
                      <AiOutlineVideoCamera className="  text-xl text-primary opacity-75" />
                    ) : (
                      <AiOutlineVideoCamera className="opacity-10 text-xl" />
                    )}
                    {item?.resumeLink ? (
                      <AiOutlineFileText className=" ml-3 text-xl text-primary opacity-75" />
                    ) : (
                      <AiOutlineFileText className=" ml-3 text-xl opacity-10" />
                    )}
                    {/* <p className="text-sm text-primary ml-auto">View More </p>{" "}
                <CiCircleChevRight className="mt-1 mx-2" />{" "} */}
                    {item?.interviewee?.lookingFor && (
                      <p className="text-sm text-black ml-auto flex">
                        Looking For :{" "}
                        <p className="text-primary">
                          {" "}
                          {item?.interviewee?.lookingFor}
                        </p>{" "}
                      </p>
                    )}{" "}
                  </p>
                  {/* </Link> */}
                </div>
              ))}
            </>
          )}
        </div>
        <div className="flex justify-center  mt-4">
          {/* {RecuiterStore.currentPage > 1 && ( */}
          {/* <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2"
            onClick={() => RecuiterStore.loadPrevUsers()}
          >
            <GrPrevious style={{ color: "white" }} />
          </button> */}
          {/* )} */}

          {/* {renderPageNumbers()} */}

          {/* {RecuiterStore.currentPage < RecuiterStore.totalPage && ( */}
          {/* <button
            className="bg-blue-500 hover:bg-blue-700  font-bold py-2 px-4 rounded ml-2"
            onClick={() => RecuiterStore.loadMoreUsers()}
          >
            <GrNext style={{ color: "white" }} />
          </button> */}
          {/* )} */}
        </div>
        <div>
          {/* <div className="flex flex-row">
     <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        // onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={10}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
      />
        </div> */}
        </div>
      </div>
      {RecuiterStore.totalPage > 1 && (
        <div>
          <ReactPaginate
            nextLabel=" >"
            className="flex justify-center items-center gap-5 my-4"
            onPageChange={handlePageClick}
            forcePage={Number(page)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={RecuiterStore.totalPage}
            previousLabel="< "
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName="active-page-item"
            activeLinkClassName="active-page-link"
            renderOnZeroPageCount={null}
          />
        </div>
      )}
      {/* <nav className="flex justify-center mx-auto my-4">
        <ul className="flex list-none rounded-md border border-gray-300">
          <li className="hidden sm:block">
            <button
              onClick={() => setPageNo(pageNo - 1)}
              className="py-2 px-4 text-gray-500 focus:outline-none hover:bg-gray-200"
            >
              Previous
            </button>
          </li>
          {pageNumbers.map((index) => (
            <li key={index}>
              <button
                onClick={() => {
                  setPageNo(index);
                  RecuiterStore.getUsers(
                    searchValue.current.value,
                    9,
                    (index - 1) * limit
                  );
                }}
                className={`py-2 px-4 text-gray-700 focus:outline-none ${
                  pageNo === index ? `bg-blue-200` : null
                }`}
              >
                {index}
              </button>
            </li>
          ))}
          <li className="hidden sm:block">
            <button
              onClick={() => setPageNo(pageNo + 1)}
              className="py-2 px-4 text-gray-500 focus:outline-none hover:bg-gray-200"
            >
              Next
            </button>
          </li>
        </ul>
      </nav> */}
    </div>
  ));

  function verificationCard() {
    return (
      <div className="  pt-3 ">
        <div className="  flex flex-col justify-center rounded items-center md:w-[60%] lg:w-[60%] w-[90%] h-[60%] md:h-[80%] lg:h-[50%] m-auto  overflow-hidden">
          <div className="flex flex-col justify-between  h-full py-5 w-[100%] md:w-[100%] lg:[100%]  ">
            <div className=" flex flex-col items-center w-[100%]">
              <img src={verify} className="w-[500px] object-cover "></img>
              <div className=" md:text-xl lg:text-2xl text-lg w-[80%]">
                <p className="text-primary text-4xl py-4 ">
                  Under Verification
                </p>
                <p>
                  Your account is currently under verification. We appreciate
                  your patience as we ensure the security and accuracy of your
                  information. Once verified, you'll have full access to our
                  platform's features. Thank you for your understanding.
                </p>
                <p>{UserStore?.userDetails?.isAccountVerified}</p>
              </div>
            </div>
            <div className="absolute right-5 bottom-10">
              {" "}
              <button className="text-primary font-bold">
                Mark all as read
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
